import moment from 'moment';

export const DISPLAY_DATETIME_FORMAT = 'MMM D, YYYY h:mm A';
export const DISPLAY_TIME_FORMAT = 'h:mm A';

export type FormatDisplayDateTimeOptions = {
  relativeDayLabels?: boolean;
  now?: string | number | Date;
};

export function formatDisplayDateTime(
  value: string | number | Date | null | undefined,
  fallback = '—',
  options: FormatDisplayDateTimeOptions = {},
): string {
  if (value == null || value === '') return fallback;

  const parsed = moment(value);
  if (!parsed.isValid()) return fallback;

  if (!options.relativeDayLabels) {
    return parsed.format(DISPLAY_DATETIME_FORMAT);
  }

  const now = options.now != null ? moment(options.now) : moment();
  if (!now.isValid()) {
    return parsed.format(DISPLAY_DATETIME_FORMAT);
  }

  if (parsed.isSame(now, 'day')) {
    return `Today, ${parsed.format(DISPLAY_TIME_FORMAT)}`;
  }

  if (parsed.isSame(now.clone().subtract(1, 'day'), 'day')) {
    return `Yesterday, ${parsed.format(DISPLAY_TIME_FORMAT)}`;
  }

  return parsed.format(DISPLAY_DATETIME_FORMAT);
}
